import { stdObject } from "../../../data/types/stdObject";

export const getInputMainData = (
  key: string,
  {
    t,
    bankAccountsList,
    expensesList,
    area,
    cPayments,
    vPayments,
    mainData = {},
  }: stdObject,
) => {
  const ratesList = area === "c" ? cPayments : vPayments;
  switch (key) {
    case "MAR":
      return [
        {
          code: "IMGMAR",
          label: t("p.image"),
          type: "image",
          imageCode: mainData.CODMAR,
          imageFormat: mainData.FORMAR,
          imageFolder: "brands",
        },
        {
          code: "NOMMAR",
          label: "p.name",
          type: "text",
          require: true,
        },
      ];
    case "CAJ":
      return [
        { code: "NOMCAJ", label: "p.name", require: true },
        {
          code: "CANCAJ",
          label: "p.quantity",
          type: "number",
          innerStyle: { width: 100, textAlign: "right" },
          calcInput: true,
          require: true,
        },
        {
          code: "TIPCAJ",
          label: "p.account",
          type: "select",
          options: [
            { label: t("p.pettyCash"), value: 0 },
            ...bankAccountsList.map((e: stdObject) => {
              return { label: e.NOMCUE, value: e.CODCUE };
            }),
          ],
          require: true,
        },
        {
          code: "FECCAJ",
          label: "p.date",
          type: "datetime-local",
          require: true,
        },
        {
          code: "FLOWCAJ",
          label: "p.transactionType",
          type: "select",
          options: [
            { label: "", value: "" },
            { label: t("p.inflow"), value: 1 },
            { label: t("p.outflow"), value: 2 },
          ],
          require: true,
        },
        {
          code: "TRACAJ",
          label: "p.transferTo",
          type: "select",
          options: [
            { label: "", value: "" },
            { label: t("p.pettyCash"), value: 0 },
            ...bankAccountsList.map((e: stdObject) => {
              return { label: e.NOMCUE, value: e.CODCUE };
            }),
          ],
        },
        {
          code: "GASCAJ",
          label: "p.expense",
          type: "select",
          options: [
            { label: "", value: "" },
            ...expensesList.map((e: stdObject) => {
              return { label: e.NOMGAS, value: e.CODGAS };
            }),
          ],
        },
        {
          code: "METCAJ",
          label: "p.method",
          type: "select",
          options: (mainData.FLOWCAJ === 2 ? cPayments : vPayments).map(
            (e: stdObject) => {
              return { label: e.NOMTPA, value: e.CODTPA };
            },
          ),
        },
        {
          code: "RESCAJ",
          label: "p.restartAmount",
          type: "checkbox",
        },
        {
          code: "FEC2CAJ",
          label: "p.approvalDate",
          type: "datetime-local",
        },
        { code: "DESCAJ", label: "p.description" },
      ];
    case "DIN":
      return [
        {
          code: "ID",
          label: "p.code",
          type: "info",
        },
        {
          code: "CANDIN",
          label: "p.quantity",
          type: "number",
          innerStyle: { width: 100, textAlign: "right" },
          calcInput: true,
          require: true,
        },
        {
          code: "TIPDIN",
          label: "p.transactionType",
          type: "select",
          options: ratesList.map((e: stdObject) => {
            return { label: e.NOMTPA, value: e.CODTPA };
          }),
          require: true,
        },
        {
          code: "FECDIN",
          label: "p.date",
          type: "datetime-local",
          require: true,
        },
        {
          code: "FEC2DIN",
          label: "p.approvalDate",
          type: "datetime-local",
        },
        {
          code: "APLDIN",
          label: "p.approved",
          type: "checkbox",
        },
        { code: "OBSDIN", label: "p.description" },
      ];
  }
};
